import axios, { AxiosResponse } from 'axios'

import { ResponseSuccess } from '@models/apiBase'
import { Response } from '@models/apiBase'
import { PrinterDataModel } from '@models/printerData'

import { PRINTER_SERVER_SECURE } from '@/constants/constant'

const PROTOCOL = PRINTER_SERVER_SECURE ? 'https:' : 'http:'

type ResponsePrint = Response<ResponseSuccess>

type ResponsePrinterOptions = Response<{ printers: Array<string> }>

interface IPrinterAPI {
  print: (signature: string, payload: PrinterDataModel) => Promise<ResponsePrint>

  getOptions: (ipAddress: string) => Promise<ResponsePrinterOptions>
}

export const PrinterAPI: IPrinterAPI = {
  print: async (signature, payload) => {
    return axios
      .post(`${PROTOCOL}//${payload.printer_ip}/printers`, payload, {
        headers: {
          'X-Signature': signature,
        },
      })
      .then((r: AxiosResponse) => r.data)
  },

  getOptions: async (ipAddress) => {
    return axios.get(`${PROTOCOL}//${ipAddress}/printers`).then((r: AxiosResponse) => r.data)
  },
}
